import { createRouter, createWebHistory } from "vue-router";
import routes from "@/router/modules/api.routes";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
